import { render, staticRenderFns } from "./remainTicket.vue?vue&type=template&id=56aa82ff"
import script from "./remainTicket.vue?vue&type=script&lang=js"
export * from "./remainTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports